import { Col, Row, Space, Typography } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import RocketlaneLogo from 'assets/svgs/rocketlane_icon_standard.svg';
import SalesforceLogo from 'assets/svgs/salesforce-logo.svg';
import { Avatar } from 'components/atoms/avatar';

const BorderdCol = styled(Col)`
  padding: var(--spacing-04);
  border-top: 1px solid var(--gray-20);
  border-bottom: 1px solid var(--gray-20);
`;

const { Text } = Typography;

export const ResourceHeader = () => (
  <Row>
    <BorderdCol flex="412px">
      <Space>
        <Avatar src={SalesforceLogo} shape="square" size="small" />
        <Text strong>
          <FormattedMessage id="settings.integrations.sf.title" />
        </Text>
      </Space>
    </BorderdCol>
    <BorderdCol flex="412px">
      <Space>
        <Avatar src={RocketlaneLogo} shape="square" size="small" />
        <Text strong>
          <FormattedMessage id="rocketlane" />
        </Text>
      </Space>
    </BorderdCol>
    <BorderdCol flex="auto">
      <Text strong>
        <FormattedMessage id="actions" />
      </Text>
    </BorderdCol>
  </Row>
);
